import { clsx } from 'clsx';

import { useDataTable } from '../../../contexts/DataTableContext.js';
import type { DataTableExpandableRowWrapperProps } from '../row-details-types.js';
import { rowDetailsWrapperCSS } from '../RowDetails.sty.js';

/**
 * Wrapper helper for the DataTable.ExpandableRow that will automatically sync
 * specific style properties like row padding for rowDensity variant settings.
 * @public
 */
export function DataTableExpandableRowWrapper(
  props: Readonly<DataTableExpandableRowWrapperProps>,
) {
  const {
    className: consumerClassName,
    'data-testid': dataTestId,
    style: consumerStyle,
    ...remainingProps
  } = props;
  const table = useDataTable();
  return (
    <div
      data-testid={dataTestId}
      {...remainingProps}
      className={clsx(
        consumerClassName,
        rowDetailsWrapperCSS({
          rowDensity: table.atoms.visualVariantConfig?.get().rowDensity,
        }),
      )}
      style={consumerStyle}
    />
  );
}
